import React from "react";
import { FaceFrownIcon } from "@heroicons/react/24/outline";

function TodosNotFound() {
  return (
    <p className="text-center mt-3">
      <FaceFrownIcon className="h-6 w-6 mx-auto" aria-hidden="true" />
      Ops! La tarea que buscas no existe
    </p>
  );
}

export { TodosNotFound };
